export var reduxKey = '@@EarningsCalculator';
export var actionKey = '@@EarningsCalculator';
//# sourceMappingURL=constants.js.map